import { ref, Ref } from 'vue';
import zxcvbn from 'zxcvbn';
import { FormLabel, LABEL_PWD_HELP, LABEL_PASSWORD_STRONGER, LABEL_PASSWORD_DONT_MATCH } from './form';

/**
 * Name name
 */
export interface PasswordValidation {
  password: Ref<string>;
  passwordConfirm: Ref<string>;
  isPasswordInvalid: Ref<boolean>;
  isPasswordConfirmInvalid: Ref<boolean>;
  passwordMessage: Ref<FormLabel | null>;
  validate(type: 'b' | 'k' | ''): void;
}

const usePasswordValidation = (minLength: number): PasswordValidation => {
  const password = ref('');
  const passwordConfirm = ref('');
  const passwordMessage: Ref<FormLabel | null> = ref(null);
  const isPasswordInvalid = ref(false);
  const isPasswordConfirmInvalid = ref(false);
  passwordMessage.value = { label: LABEL_PWD_HELP, params: [minLength] };

  function clearPasswordMessage() {
    isPasswordInvalid.value = false;
    isPasswordConfirmInvalid.value = false;
    passwordMessage.value = { label: LABEL_PWD_HELP, params: [minLength] };
  }

  function validate(type: 'b' | 'k' | '') {
    const wasValid = !isPasswordInvalid.value;
    const isKeypress = type === 'k';
    const isBlur = type === 'b';
    const passwordValue = password.value;
    const passwordConfirmValue = passwordConfirm.value;

    if (isKeypress && passwordValue.length === 0) {
      clearPasswordMessage();
      return;
    }

    if (isKeypress && wasValid) {
      // wait blur before validating
      return;
    }

    if (isBlur && passwordValue.length === 0) {
      clearPasswordMessage();
      return;
    }

    if (passwordValue.length < minLength) {
      isPasswordInvalid.value = true;
      isPasswordConfirmInvalid.value = false;
      passwordMessage.value = { label: LABEL_PWD_HELP, params: [minLength] };
      return;
    }

    const passwordScrore = zxcvbn(passwordValue);

    if (passwordScrore.score < 2) {
      isPasswordInvalid.value = true;
      isPasswordConfirmInvalid.value = false;
      passwordMessage.value = { label: LABEL_PASSWORD_STRONGER };
      return;
    }

    if (passwordValue !== passwordConfirmValue && (type === '' || passwordConfirmValue.length > 0)) {
      isPasswordInvalid.value = true;
      isPasswordConfirmInvalid.value = true;
      passwordMessage.value = { label: LABEL_PASSWORD_DONT_MATCH };
      return;
    }

    passwordMessage.value = {};
    isPasswordInvalid.value = false;
    isPasswordConfirmInvalid.value = false;
  }

  return {
    password,
    passwordConfirm,
    passwordMessage,
    isPasswordInvalid,
    isPasswordConfirmInvalid,
    validate,
  };
};

export default usePasswordValidation;
